import { CopilotConversationContentBlock } from 'models/copilot/copilotConversation';
import { parseFileBlockPayload } from 'models/copilot/copilotFileBlock';
import { CopilotFileCard } from './CopilotFileCard';

interface ICopilotFileBlockProps {
  block: CopilotConversationContentBlock;
  sessionId?: number;
}

// A File block: the renderer's host for the file's card; a payload that names no file renders nothing.
export const CopilotFileBlock = (props: ICopilotFileBlockProps) => {
  const file = parseFileBlockPayload(props.block.payload);
  if (!file) return null;

  return <CopilotFileCard block={props.block} file={file} sessionId={props.sessionId} />;
};
